import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'
import { LOGIN_PAGE } from '../../constents/routesSrtings';
import { Loader } from '../../constents/components';
import useRedirect from '../../Hooks/Auth/useRedirect';


const Protection = ({ children }) => {

    // const Navigate = useNavigate();
    const isUserAuthenticated = useSelector((store) => store?.authStates?.isUserAuthenticated);
    const isUserLoading = useSelector((store) => store?.authStates?.loading);
    const { redirectUrlSetter } = useRedirect();

    // return children;

    if (isUserLoading) {
        return <Loader />
    }
    else if (isUserAuthenticated) {
        return children;
    }
    else {
        redirectUrlSetter();
        return <Navigate to={LOGIN_PAGE} />
    }
}
export default Protection;